<template>
  <div class="page page--maintenance">
    <div class="page-heading">{{ $route.params.suburb }} Road block & disruptions</div>
    <div v-if="items.length">
      <div class="maintenance-item" v-for="item in items" v-bind:key="item.id">
        <div class="maintenance__main">
          <span class="maintenance-item__street">{{ item.street }}</span> - <span
            class="maintenance-item__type">{{ item.typeOfWork }}</span>
        </div>
        <div class="maintenance-item__impact">{{ item.impact }}</div>
        <div class="maintenance-item__date">
          {{ ISOtoNZDate(item.startDate) }} - {{ ISOtoNZDate(item.finishDate) }}
        </div>
      </div>
    </div>
    <div class="page-heading" v-else>No maintenance in this suburb.</div>
  </div>
</template>

<script>
export default {
  name: "RoadMaintenance",
  data() {
    return {
      items: [],
    }
  },
  mounted() {
    this.loadSuburbRoadMaintenance(this.$route.params.suburb);
  },
  methods: {
    ISOtoNZDate(isoDate) {
      if (isoDate === undefined)
        return '';
      let parts = isoDate.split('-');
      parts.reverse();
      return parts.join('/');
    },
    async loadSuburbRoadMaintenance(suburb) {
      const response = await fetch('https://api-ap-northeast-1.graphcms.com/v2/cknbjpd1wcms901z8adus4lcr/master', {
        method: 'post',
        headers: {
          Authorization: `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE2MTgwNTMxNzQsImF1ZCI6WyJodHRwczovL2FwaS1hcC1ub3J0aGVhc3QtMS5ncmFwaGNtcy5jb20vdjIvY2tuYmpwZDF3Y21zOTAxejhhZHVzNGxjci9tYXN0ZXIiLCJodHRwczovL21hbmFnZW1lbnQtbmV4dC5ncmFwaGNtcy5jb20iXSwiaXNzIjoiaHR0cHM6Ly9tYW5hZ2VtZW50LmdyYXBoY21zLmNvbS8iLCJzdWIiOiIwM2Q1YjM5YS0xOTY0LTRlMzMtODhmYi0zYWUwYjkxMjIxMDYiLCJqdGkiOiJja25ibjJ6dmVkanV3MDF5emczOXpiYTg1In0.ujhGHH-Kx6b3YUqC6Mc3yqS6EDIr6ONbGkK8FeiAPsMHeK24I2Kx2SnjTqkpchaExWhG6WZOP55yYhiPPI_ujSyIA4TReERCUvTid_Vaw1ExvLJBLmRjXh5Nz3293q0Lmlga18mfPurRv8iu87gYZPfb7bnIuQ_3Vfr7W32smsyIBLiwV_Z2CwwofmvtXeo5wcO0ZUbYtKcAUznKrNjcC_9K1xcu-P6_RkfEavjA91GH8vm5Ge85GQv09Lj6Srr0rB5x94Q3Ac0Bj4j74270773L-6gf8ErYu7EEGchspQtoN7wgXLfoHJf27QgAls5Jenz-nPcGbVYIKdEXIyI0qeeq4b3PN-6Ib_CTPK82bq5oDUxUIwwG1moqO8CtMblBq8ENjlmaorgWmkP0Sjw-JQi3AG3Qm3GfquiF2hnJAWJpiGTCpyarqiVX7mq8V6O51nwhheTLLX4pmZmxXorsq5vpob-qh571Jfo__5VgHYrfrsB-PQpRZgErUXPuw87AOiPQ4Us8PkG8CKQhOwr5SelBsbq1V2qaCfvO2tWGuWKrIZm0URCt8OMg27ESCea-HlYZ4ILi3MU90FLuNhiQ0B9G5DIDQgf5-QYiIMlio1zNKtufsf_kkFdpSbRxwYwzDAY_9TWIpmKL-1nOj5B81-d52q-UGWjFmvxb3PJ8DnU`,
        },
        body: JSON.stringify({
          query: `
              query MyQuery {
                maintenances(where: {suburb: "${suburb}"}, orderBy: startDate_ASC) {
                  id
                  impact
                  startDate
                  finishDate
                  street
                  suburb
                  typeOfWork
                }
              }
            `
        })
      });
      const result = await response.json();
      this.items = result.data.maintenances;
    }
  }
}
</script>
